



































import { Component, Vue } from 'vue-property-decorator';
import CircleButton from '@/components/CircleButton.vue';
import Modal from '@/components/Modal.vue';
import LongButton from '@/components/LongButton.vue';

import pageContent from '@/contents/decompression';

@Component({
  components: {
    CircleButton,
    Modal,
    LongButton,
  },
})
export default class Education extends Vue {
  public modalOpen = '';

  public pageContent = pageContent;

  close(id: string) {
    this.modalOpen = this.modalOpen === id ? '' : id;
  }
}

